<template>
  <div class="sidebar">
    <Navigation />
    <Search class="search" :tags="getTags" ref="search" />
  <v-scroll-y-transition>
    <v-list
      expand
      flat
      tile
      class="pa-0"
      v-if="
        category.activeCategories.length > 0 || banner.tagQuery.length > 0
      "
    >
      <v-list-item class="pa-0">
        <v-btn
          text
          small
          :ripple="false"
          @click="clearAll"
          class="subtitle-1 font-weight-medium primary--text"
          >Clear Filters
        </v-btn>
      </v-list-item>
    </v-list>
  </v-scroll-y-transition>
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters, mapState, mapActions } from "vuex";
export default Vue.extend({
  name: "Sidebar",
  components: {
    Navigation: () => import("@/components/Navigation"),
    Search: () => import("@/components/SearchAutocomplete"),
  },
  computed: {
    ...mapGetters(["getTags"]),
    ...mapState(["category", "banner"]),
  },
  methods: {
    ...mapActions(["clearActiveCategories"]),
    clearAll() {
      this.clearFilters();
      this.clearActiveCategories();
    },
    async clearFilters() {
      const queryObj = Object.assign({}, this.$route.query);
      delete queryObj.category;
      this.$refs.search.clearTags();
    },
  },
});
</script>

<style lang="scss">
.sidebar {
  height: 100%;
  padding: 0 80px;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  &::after {
    content: "copyright by rtbhouse";
    font-weight: 300;
    font-style: normal;
    font-size: 10px;
    margin: auto 0 30px;
    padding-top: 60px;
  }
}

@media (max-width: 1080px) {
  .sidebar {
    height: 100%;
    width: 100%;
    padding: 165px 24px 0 80px;

    .link {
      font-size: 1.1em;
    }

    &::after {
      left: 26px;
      bottom: 25px;
    }
  }
}

@media (max-width: 800px) {
  .sidebar {
    padding: 140px 16px 0;
  }
}
</style>
